<template>
    <div v-if="manualDnssecAvailable && dnssecKeys !== null">
        <div class="page-block__item | u-border-bottom-flush">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                        <span class="page-block__item-content-title">
                            {{ trans('domain.dnssec.title') }}
                        </span>
                    </div>
                    <!--
                 -->
                    <div class="layout__item u-2/3-desk">
                        <dnssec-status :label="trans('domain.dnssec.title')" :status="dnssecStatus" />
                    </div>
                </div>
            </div>
            <div class="page-block__item-nav">
                <button
                    v-if="dnssecKeys.length === 0"
                    @click="showPublicKeyModal"
                    type="button"
                    class="btn btn--ghost btn--ghost-full-width"
                >
                    {{ trans('domain.dnssec.enable') }}
                </button>

                <button
                    v-if="dnssecKeys.length > 0"
                    @click="showConfirmDisableModal()"
                    type="button"
                    class="btn btn--ghost btn--ghost-full-width"
                >
                    {{ trans('domain.dnssec.disable') }}
                </button>
            </div>
        </div>

        <div class="page-block__actions" v-if="dnssecKeys.length > 0">
            <div class="page-block__actions-item">
                <div class="u-text-right">
                    <button @click="showPublicKeyModal" type="button" class="btn btn--link">
                        {{ trans('domain.dnssec.publicKey') }}
                        <img src="/img/arrow-right-orange.f6ca898d.svg" class="u-margin-left-inline" />
                    </button>
                </div>
            </div>
        </div>

        <public-key-modal
            v-if="publicKeyModalVisible"
            @close="closePublicKeyModal"
            :dnssecKeys="dnssecKeys"
            :domain="domain"
        />

        <confirm-disable-modal
            v-if="confirmDisableModalVisible"
            @close="closeConfirmDisableModal"
            :domain="domain"
        />
    </div>
</template>

<script>
import PublicKeyModal from './DomainDnssecPublicKeyModal.vue';
import DnssecStatus from './DomainDnssecStatus.vue';
import { DnssecApi } from 'relapp-technical-management';
import ConfirmDisableModal from './DomainDnssecDisableConfirmation.vue';

export default {
    components: {
        ConfirmDisableModal,
        PublicKeyModal,
        DnssecApi,
        DnssecStatus
    },
    props: {
        dnssecKeys: {
            type: Array,
            default: () => null
        },
        domain: {
            type: String,
            required: true
        }
    },
    /**
     * Called after the instance has been created.
     */
    created() {
        DnssecApi.manualDnssecAvailable(this.domain).then(response => {
            this.manualDnssecAvailable = response.data.data;
        });
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            confirmDisableModalVisible: false,
            publicKeyModalVisible: false,
            manualDnssecAvailable: false
        };
    },
    computed: {
        /**
         * Status label.
         *
         * @return {string}
         */
        dnssecStatus() {
            if (this.dnssecKeys.length > 0) {
                return 'active';
            } else {
                return 'unprotected';
            }
        }
    },
    methods: {
        /**
         * Show public key modal and form.
         */
        showPublicKeyModal() {
            this.publicKeyModalVisible = true;
        },
        /**
         * Close public key modal and form.
         */
        closePublicKeyModal() {
            this.publicKeyModalVisible = false;
        },
        /**
         * Show the modal when you want to disable DNSSEC.
         */
        showConfirmDisableModal() {
            this.confirmDisableModalVisible = true;
        },
        /**
         * Close the modal when DNSSEC has been disabled.
         */
        closeConfirmDisableModal() {
            this.confirmDisableModalVisible = false;
        }
    }
};
</script>
